var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardInvoices(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Account/Invoices") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 -1.77635684e-15 24.9998 -1.77635684e-15 24.9998 15.202 0 15.202"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0 25 0 25 15.2275 0 15.2275"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Account/Invoices",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000200, 9.798000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.449,15.202 L4.551,15.202 C2.041,15.202 0,13.161 0,10.651 L0,1 C0,0.447 0.447,-1.77635684e-15 1,-1.77635684e-15 C1.553,-1.77635684e-15 2,0.447 2,1 L2,10.651 C2,12.057 3.144,13.202 4.551,13.202 L20.449,13.202 C21.855,13.202 23,12.057 23,10.651 L23,9.547 C23,8.994 23.447,8.547 24,8.547 C24.553,8.547 25,8.994 25,9.547 L25,10.651 C25,13.161 22.959,15.202 20.449,15.202",
    id: "Fill-1",
    fill: "#282827"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,15.2275 C23.447,15.2275 23,14.7805 23,14.2275 L23,4.5505 C23,3.1445 21.855,1.9995 20.449,1.9995 L4.551,1.9995 C3.145,1.9995 2,3.1445 2,4.5505 L2,5.6885 C2,6.2415 1.553,6.6885 1,6.6885 C0.447,6.6885 0,6.2415 0,5.6885 L0,4.5505 C0,2.0405 2.041,-0.0005 4.551,-0.0005 L20.449,-0.0005 C22.959,-0.0005 25,2.0405 25,4.5505 L25,14.2275 C25,14.7805 24.553,15.2275 24,15.2275",
    id: "Fill-4",
    fill: "#282827"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.4091,16.9323 L7.5911,16.9323 C6.9551,16.9323 6.4401,17.4473 6.4401,18.0833 C6.4401,18.7183 6.9551,19.2333 7.5911,19.2333 L17.4091,19.2333 C18.0451,19.2333 18.5601,18.7183 18.5601,18.0833 C18.5601,17.4473 18.0451,16.9323 17.4091,16.9323",
    id: "Fill-7",
    fill: "#282827"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.178,13.2183 L13.178,12.8343 L13.31,12.8003 C13.751,12.6893 14.117,12.4883 14.4,12.2033 C14.732,11.8723 14.901,11.4543 14.901,10.9613 C14.901,10.0723 14.357,9.4993 13.285,9.2583 L12.333,9.0483 C12.045,8.9843 11.915,8.9133 11.857,8.8653 C11.782,8.8043 11.749,8.7343 11.749,8.6463 C11.749,8.5053 11.816,8.3913 11.953,8.2993 C12.246,8.1013 12.906,8.1423 13.178,8.2063 C13.337,8.2433 13.476,8.2863 13.6,8.3393 C13.844,8.4393 14.037,8.4483 14.197,8.3763 C14.358,8.3043 14.474,8.1833 14.535,8.0263 C14.598,7.8673 14.605,7.7063 14.559,7.5323 C14.512,7.3623 14.401,7.2263 14.23,7.1323 C14.062,7.0273 13.883,6.9473 13.688,6.8923 C13.563,6.8583 13.44,6.8263 13.317,6.8003 L13.178,6.7723 L13.178,6.4213 C13.178,6.2373 13.113,6.0733 12.989,5.9483 C12.869,5.8303 12.679,5.7793 12.51,5.7663 C12.33,5.7683 12.163,5.8343 12.052,5.9493 C11.928,6.0733 11.864,6.2373 11.864,6.4213 L11.864,6.8073 L11.732,6.8413 C11.278,6.9563 10.903,7.1653 10.617,7.4603 C10.29,7.7993 10.124,8.2183 10.124,8.7043 C10.124,9.6213 10.663,10.2053 11.725,10.4433 L12.664,10.6423 C12.904,10.6963 13.068,10.7593 13.154,10.8303 C13.231,10.8963 13.268,10.9743 13.268,11.0713 C13.268,11.1783 13.21,11.2713 13.092,11.3563 C12.964,11.4433 12.73,11.4883 12.409,11.4883 C12.076,11.4883 11.799,11.4553 11.584,11.3913 C11.371,11.3263 11.203,11.2653 11.085,11.2073 C10.97,11.1563 10.859,11.1313 10.755,11.1313 C10.7,11.1313 10.648,11.1393 10.599,11.1533 C10.459,11.1953 10.344,11.2753 10.258,11.3933 C10.171,11.5103 10.119,11.6423 10.104,11.7863 C10.088,11.9303 10.114,12.0703 10.179,12.2033 C10.245,12.3383 10.359,12.4443 10.516,12.5163 C10.669,12.5903 10.861,12.6613 11.103,12.7373 C11.286,12.7903 11.491,12.8323 11.71,12.8603 L11.864,12.8793 L11.864,13.2183 C11.864,13.4063 11.925,13.5643 12.047,13.6873 C12.288,13.9423 12.739,13.9423 12.989,13.6913 C13.116,13.5633 13.178,13.4083 13.178,13.2183",
    id: "Fill-9",
    fill: "#282827"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardInvoices);
export default __webpack_public_path__ + "static/media/dashboard_invoices.d8b9b49249d674f6d00afa240741c084.svg";
export { ForwardRef as ReactComponent };